import { useEffect } from 'react'
import { getCatchAddress } from 'dflocationsdk'
import { loadConfig, loadMenus } from './service'
import {
  checkMaxOrBFDApp,
  checkXcx,
  getQueryString,
  u_getDomain,
  checkUnifyShop,
  u_getUnion,
} from '@/utils'
import { HeadType } from '@/global'
import { TLang } from '@/utils/lang'

export const useInitHeader = (
  fun: (config: CommonHomeHeaderModel | CommonClassHeaderModel | null) => void,
  headType: HeadType,
  unionConfig: any
) => {
  const requestDomain = u_getDomain()
  /** 校验是否是小程序或东福app终端 */
  const checkTerminal = checkXcx() || checkMaxOrBFDApp()

  /** 城市点击操作 */
  const handleCity = () => {
    const url = `${requestDomain}/max-pagesite/citylist?allowback=true&returnurl=${encodeURIComponent(
      window.location.href
    )}`
    window.df_sdk_common.location.href = url
  }
  /** 客服点击操作 */
  const handleService = () => {
    const _win: any = window
    _win?.qimoChatClick()
  }

  /** 汉堡包点击操作 */
  const handleMenus = () => {
    createMenus()
  }

  /** 获取城市信息 */
  const addressCatch = getCatchAddress()
  let address: any = null
  if (addressCatch) {
    address = JSON.parse(addressCatch)
  }

  const commonHomeConfig: CommonHomeHeaderModel = {
    // leftHomeShow: checkMaxOrBFDApp() ? false : true,
    leftHomeShow: false,
    leftHomeIcon:
      'https://oss-dffl-ops.dongfangfuli.com/prd/fore-cms-h5/pagesite/images/home-66b6.png',
    leftHomeUrl: '',
    leftHomeText: '首页',

    leftLogoShow: true,
    leftLogoIcon:
      'https://oss-dffl-ops.dongfangfuli.com/prd/fore-life-h5/tmall/static/media/logo.5c7df546.png',
    leftLogoUrl: '',

    rightCityShow: true,
    rightCityText: address?.cityName || '上海',
    rightCityClick: handleCity,

    rightSearchIcon:
      'https://oss-dffl-ops.dongfangfuli.com/prd/fore-cms-h5/pagesite/images/search-c1ab.png',
    rightSearchShow: true,
    rightSearchUrl: '',
    rightSearchText: '搜索',

    rightServiceIcon:
      'https://oss-dffl-ops.dongfangfuli.com/prd/fore-cms-h5/pagesite/images/service-09ae.png',
    rightServiceShow: true,
    rightServiceText: '客服',
    rightServiceClick: handleService,

    rightMenusShow: !checkTerminal,
    rightMenusIcon:
      'https://oss-dffl-ops.dongfangfuli.com/prd/fore-cms-h5/pagesite/images/hamburger-a52a.png',
    rightMenusText: '更多',
    rightMenusClick: handleMenus,
  }

  const commonClassConfig: CommonClassHeaderModel = {
    leftBackShow: true,
    leftBackIcon: require('@/component/HeaderPart/icon/back.png'),
    leftBackUrl: '',
    leftBackText: '',

    contentText: '商品分类页',

    rightSearchIcon: require('@/component/HeaderPart/icon/searchIcon.png'),
    rightSearchShow: true,
    rightSearchUrl: '',
    rightSearchText: '',
  }

  useEffect(() => {
    if (!headType || (!checkUnifyShop() && !u_getUnion())) {
      fun(null)
      return
    }
    if (unionConfig) {
      const { mallUnionConfigDto, homePageUrl, themeConfig } = unionConfig?.Data
      switch (headType) {
        case HeadType.HomeCommon:
          commonHomeConfig.leftHomeUrl = homePageUrl
          commonHomeConfig.leftLogoUrl =
            mallUnionConfigDto?.h5ShopLogo || mallUnionConfigDto?.logo
          commonHomeConfig.rightSearchUrl = mallUnionConfigDto?.h5SearchUrl
          commonHomeConfig.leftLogoIcon = themeConfig?.logoUrl
          fun(commonHomeConfig)
          break
        case HeadType.ClassificationCommon:
          fun(commonClassConfig)
          break
      }
    }
  }, [headType, unionConfig])
}

/** 创建菜单 */
export const createMenus = async () => {
  const union = u_getUnion()
  const channelId = getQueryString('channelId')
  const _win: any = window

  if (union) {
    const unionConfig = await loadConfig()
    const {
      homePageUrl = '',
      userCentUrl = '',
      shoppingCartUrl = '',
      mallUnionConfigDto,
    } = unionConfig.Data
    const bfdMenus = [
      {
        key: 'home',
        label: TLang('商城首页', 'globalLang'),
        icon: '',
        url: homePageUrl,
      },
      {
        key: 'center',
        label: TLang('我的', 'globalLang'),
        icon: '',
        url: userCentUrl,
      },
    ]
    loadMenus(channelId).then((res) => {
      let unionMenus = []
      if (res.Status === 0) {
        const mallChannelList = res.Data?.mallChannelList
        if (mallChannelList) {
          unionMenus = mallChannelList.map((item: any) => {
            return {
              label: item.name,
              key: item.code.toLocaleLowerCase(),
              url: item.url,
              icon: item.h5ImagePath || '',
            }
          })
        }
      }
      _win.createMenu(bfdMenus, unionMenus, null, () => {})
    })
  } else {
    _win.createMenu(null, null, null, () => {})
  }
}

export interface CommonHomeHeaderModel {
  /** 左侧小房子显示控制 */
  leftHomeShow?: boolean
  /** 左侧小房子Icon */
  leftHomeIcon?: string
  /** 左侧小房子跳转链接 */
  leftHomeUrl?: string
  leftHomeText?: string

  /** 左侧logo显示控制 */
  leftLogoShow?: boolean
  /** 左侧logo icon */
  leftLogoIcon?: string
  /** 左侧logo链接 */
  leftLogoUrl?: string

  /** 右侧城市显示控制 */
  rightCityShow?: boolean
  rightCityText?: string
  rightCityClick?: () => void

  /** 右侧搜索显示控制 */
  rightSearchShow?: boolean
  /** 右侧搜索跳转链接 */
  rightSearchUrl?: string
  rightSearchIcon?: string
  rightSearchText?: string

  /** 右侧客服显示控制 */
  rightServiceShow?: boolean
  rightServiceIcon?: string
  rightServiceText?: string
  rightServiceClick?: () => void

  /** 右侧菜单显示控制 */
  rightMenusShow?: boolean
  rightMenusIcon?: string
  rightMenusText?: string
  rightMenusClick?: () => void
}

export interface CommonClassHeaderModel {
  leftBackShow?: boolean
  leftBackIcon?: string
  leftBackUrl?: string
  leftBackText?: string
  leftBackClick?: () => void

  /** 中间区域显示文案 */
  contentText?: string

  /** 右侧搜索显示控制 */
  rightSearchShow?: boolean
  /** 右侧搜索跳转链接 */
  rightSearchUrl?: string
  rightSearchIcon?: string
  rightSearchText?: string
  rightSearchClick?: () => void
}
